module.exports = __webpack_public_path__ + "img/typing_technique_icon.f013dcbb.png";